import { withStyles } from '@material-ui/core';
import { withAppConfig } from '../../../../../appConfigContext';
import Label from './common/Label';
import ExceptionAndReturnDetails from './ExceptionAndReturnDetails';
import appConstants from '../../../../../appConstants';
import Value from './common/Value';
import { EXCEPTION_FLOW } from '../DriverPopUp/common/constants';
import { parseExceptionConfig } from '../DriverPopUp/EditStopDialog/ProcessDelivery/ExceptionDetails/utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  labelContainer: {
    marginBottom: 8
  },
  detailsContainer: {
    display: 'flex'
  }
});

const ReturnDetails = ({ classes, returnDetail, configJSON }) => {
  const exceptionFlow = parseExceptionConfig(configJSON?.exceptionConfig)?.exceptionFlow;
  const isBothFlow = exceptionFlow === EXCEPTION_FLOW.BOTH;
  const showAdeNumber = isBothFlow && returnDetail?.adeNumber != null && returnDetail?.adeNumber !== '';

  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        <Label labelText="Return Details" />
      </div>
      {showAdeNumber && (
        <div className={classes.labelContainer}>
          <Value value={`ADE# ${returnDetail.adeNumber}`} />
        </div>
      )}
      <div className={classes.detailsContainer}>
        <ExceptionAndReturnDetails detail={returnDetail} type={appConstants.DELIVERY_CODE.RTN} />
      </div>
    </div>
  );
};

export default withAppConfig(withStyles(styles)(ReturnDetails));
